import React, { forwardRef, ReactElement } from 'react';

export interface ProgressiveImageProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  shouldLazyLoad?: boolean;
}

const ProgressiveImage = forwardRef<HTMLImageElement, ProgressiveImageProps>(
  function ForwardedProgressiveImage(
    {
      id,
      className,
      src,
      alt = '',
      height,
      width,
      shouldLazyLoad = false,
      ...other
    }: ProgressiveImageProps,
    ref
  ): ReactElement {
    const loadingType = shouldLazyLoad ? 'lazy' : 'eager';

    return (
      <img
        ref={ref}
        className={className}
        id={id}
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading={loadingType}
        {...other}
      />
    );
  }
);

export default ProgressiveImage;
